import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import screencheck from "./screencheck";

gsap.registerPlugin(ScrollTrigger);

$(document).ready(function() {

    // gsap.to(".services-logo", {
    //     yPercent: -50,
    //     ease: "none",
    //     scrollTrigger: {
    //       trigger: ".services-logo",
    //       // start: "top bottom", // the default values
    //       // end: "bottom top",
    //       scrub: true
    //     }, 
    // });

    if($('.services-logo').length) {
        // if (!screencheck(991)) {
            // gsap.set('.services-logo', { yPercent: 50 })
            // gsap.to(".services-logo", {
            //     // marginBottom: '-30%',
            //     // yPercent: -30,
            //     // marginBottom: '-200px',
            //     y: '-200px',
            //     ease: "none",
            //     scrollTrigger: {
            //         trigger: ".banner-section",
            //         // start: "bottom bottom", // the default values
            //         start: "top top+=100",
            //         end: "bottom bottom",
            //         // end: "bottom+=80 bottom+=80",
            //         // end: "+=100",
            //         scrub: true,
            //         // markers: true
            //     }, 
            // });

            gsap.to(".video-box", {
                y: '200px',
                ease: "none",
                scrollTrigger: {
                    trigger: ".banner-section",
                    // start: "bottom bottom", // the default values
                    start: "top top",
                    end: "100%",
                    // end: "bottom+=80 bottom+=80",
                    // end: "+=100",
                    scrub: true,
                    // markers: true
                }, 
            });
        
            // gsap.to(".services-logo-row", {
            //     marginBottom: '-30%',
            //     ease: "none",
            //     scrollTrigger: {
            //         trigger: ".banner-section",
            //         // start: "bottom bottom", // the default values
            //         start: "top top",
            //         end: "bottom bottom",
            //         // end: "bottom+=80 bottom+=80",
            //         // end: "+=100",
            //         scrub: true,
            //         // markers: true
            //     }, 
            // });

            gsap.set('.intro-card-main', { yPercent: screencheck(991) ? 10 : 40 })
            // gsap.set('.intro-card-main', { yPercent: 10 })
            gsap.to(".intro-card-main", {
                yPercent: 0,
                ease: "none",
                scrollTrigger: {
                    trigger: ".intro-card-main",
                    start: "top bottom", // the default values
                    end: "bottom bottom-=350",
                    scrub: true,
                    // markers: true
                }, 
            });
        // }
    }



    // gsap.set('.footer-top', { yPercent: 30 })
    // const uncover = gsap.timeline({ paused:true })

    // uncover.to('.footer-top', { yPercent: 0, ease: 'none' });
    // ScrollTrigger.create({  
    //     trigger: '.footer-top',
    //     // start: 'top bottom',
    //     start: 'top center',
    //     // end: 'top top',
    //     end: '+=50%',
    //     animation: uncover,
    //     scrub: true,
    //     markers: true
    // })

    // gsap.set('.footer-bottom', { yPercent: -30 })
    // const uncover = gsap.timeline({ paused:true })

    // uncover.to('.footer-bottom', { yPercent: 0, ease: 'none' });
    // ScrollTrigger.create({  
    //     trigger: '.footer-bottom',
    //     // start: 'top bottom',
    //     start: 'top center',
    //     // end: 'top top',
    //     end: 'bottom center',
    //     animation: uncover,
    //     scrub: true,
    //     markers: true
    // })

    if($('.footer-bottom').length && $('.footer-top').length) {
        // if (!screencheck(991)) {
            // gsap.set('.footer-bottom', { yPercent: -30 })
            gsap.set('.footer-bottom', { y: '-100px' })
            gsap.to(".footer-bottom", {
                y: 0,
                ease: "none",
                scrollTrigger: {
                    trigger: "#footer",
                    // start: "bottom bottom", // the default values
                    start: "top center",
                    // end: "bottom bottom",
                    end: "bottom-=100 bottom",
                    // end: "bottom bottom",
                    // end: "bottom+=80 bottom+=80",
                    // end: "+=100",
                    scrub: true,
                    // markers: true
                }, 
            });
        // }
    }

    // gsap.to(".footer-top", {
    //     yPercent: -50,
    //     ease: "none",
    //     scrollTrigger: {
    //     trigger: ".footer-top",
    //     // start: "bottom bottom", // the default values
    //     start: "+=100",
    //     // end: "bottom top",
    //     // end: "+=100",
    //     scrub: true,
    //     markers: true
    //     }, 
    // });
    
    // Scroll animation
    if($('.ani-element').length){
        const cards = document.querySelectorAll('.ani-element');
        const observer = new IntersectionObserver( entries => {
            // console.log(entries[0]);
            entries.forEach(entry => {
                entry.target.classList.toggle("show", entry.isIntersecting);
                // IF THE ELEMENT IS INTERSECTING, ADD THE CLASS SHOW
                if(entry.isIntersecting) observer.unobserve(entry.target);
                });
            },{
                // root: document.querySelector('#scrollArea'), //This will be scrollble area like body or div
                rootMargin: '0px 0px -150px 0px', // This will be margin from the top of the screen and bottom of the screen and it can be Negative (-100)
                // threshold: 0.5, // This will be the percentage of the element that is visible in the viewport
            }
        );

        // const lastCardobserver = new IntersectionObserver( entries => {
        //     const lastCard = entries[0];
        //     if(!lastCard.isIntersecting) return;
        //     lastCardobserver.unobserve(lastCard.target);
        //     lastCardobserver.observe(document.querySelector('.ani-element:last-child'));
        // })

        // lastCardobserver.observe(document.querySelector('.ani-element:last-child'));

        cards.forEach(card => {
            observer.observe(card);
        });
    }

    
});